class BundleBuilder {
  constructor(container, options) {
    this.container = container;
    this.products = options.products;
    this.settings = options.settings;
    this.state = {
      selectedProducts: [],
      showCart: true,
      bundleSize: 0,
      showDetails: false
    };
  }

  init() {
    this.render();
    this.attachEventListeners();
  }

  getBundlePrice() {
    return this.settings.bundlePrices[this.state.bundleSize] || 
           (this.state.selectedProducts.length * this.products[0].price);
  }

  async addToCart() {
    const items = this.state.selectedProducts.map(product => ({
      id: product.variants[0].id,
      quantity: 1,
      properties: {
        '_bundle_id': Date.now(),
        '_bundle_size': this.state.bundleSize,
        '_bundle_discount': ((this.state.selectedProducts.length * this.products[0].price) - this.getBundlePrice()).toFixed(2)
      }
    }));

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Failed to add to cart');
      window.location.href = '/cart';
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
    }
  }

  render() {
    // All the HTML from our React component, but using regular DOM manipulation
    this.container.innerHTML = `
      <div class="min-h-screen bg-white">
        <!-- Bundle Size Selector -->
        <div class="sticky top-0 z-40 w-full bg-white shadow-sm">
          <!-- ... rest of the HTML structure ... -->
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    // Add click handlers for buttons
    const bundleSizeButtons = this.container.querySelectorAll('[data-bundle-size]');
    bundleSizeButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.state.bundleSize = parseInt(button.dataset.bundleSize);
        this.state.selectedProducts = [];
        this.render();
      });
    });
    // ... add other event listeners ...
  }
}